/**
 * R232g: derived "effective stats" — суммирует bonus'ы от всех equipped
 * items. Юзер: "вещи указывают +40 хп, а реально не прибавляется".
 *
 * Server использует базовые pow/hp без equipment, но КЛИЕНТ показывает
 * всё что подписано. Раньше item stats были чисто декорацией. Теперь
 * это derived helper — Component'ы (CharacterPanel, HUD player frame)
 * могут вызывать чтобы показать "real" hpMax = baseHp + sum(equipped.hp).
 */

import { ITEMS, type Slot } from '../data/equipment.js';

export interface BonusStats {
  hp: number;
  resource: number;
  armor: number;
  pow: number;
  crit: number;
  haste: number;
  mastery: number;
  vers: number;
}

export const ZERO_BONUS: BonusStats = {
  hp: 0, resource: 0, armor: 0, pow: 0,
  crit: 0, haste: 0, mastery: 0, vers: 0,
};

export function computeEquipmentBonuses(
  equipped: Partial<Record<Slot, string>>,
): BonusStats {
  const out = { ...ZERO_BONUS };
  for (const slot of Object.keys(equipped) as Slot[]) {
    const id = equipped[slot];
    if (!id) continue;
    const item = ITEMS.find((i) => i.id === id);
    if (!item) continue;
    out.hp       += item.stats.hp ?? 0;
    out.resource += item.stats.resource ?? 0;
    out.armor    += item.stats.armor ?? 0;
    out.pow      += item.stats.pow ?? 0;
    out.crit     += item.stats.crit ?? 0;
    out.haste    += item.stats.haste ?? 0;
    out.mastery  += item.stats.mastery ?? 0;
    out.vers     += item.stats.vers ?? 0;
  }
  return out;
}
